export function roundPrice(price: number, decimalPlaces: number = 2): string {
  const p = Math.pow(10, decimalPlaces);

  return (Math.round(price * p) / p).toFixed(decimalPlaces);
}
